import Grid from '@material-ui/core/Grid';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPLink from 'UI/components/atoms/FPLink';
import Text from 'UI/components/atoms/Text';
import ProfileStatusChip from 'UI/components/molecules/ProfileStatusChip';

import { EntitySummary } from '../EntitySummary';
import { LayoutBase } from '../LayoutBase';

const COPIES = strings.inventoryProfiles.common;
const COMPANY_LINK_PROPS = { type: 'local', url: EntityRoutes.CompanyProfile, target: '_self' };

/**
 * The summary band under the title. It lays out what format<Entity>Response already
 * decided; it guesses no field. Same layout as V1's ProfileSummary: company and location
 * on the left (plus the status chip), EntitySummary on the right. LayoutBase and EntitySummary
 * are V2 copies of the V1 ones, which are deleted with V1. The chip is rendered here
 * from `status`, with the seven explicit props of V1's ProfileStatusChip, so no container
 * builds it.
 * @param {Object} props
 * @param {{ id?: number|string, name?: string } | null} [props.company] Link when it has an id
 * @param {string | null} [props.location] Already formatted ("City, ST")
 * @param {{
 *   inventoryType?: string, itemStatus?: string, subStatus?: string, optOutStatus?: string,
 *   emailValidationStatus?: string, otherEmailValidationStatus?: string, entityTypeId: number
 * } | null} [props.status] `status` of format<Entity>Response; the fields an entity lacks stay undefined
 * @param {{ date?: string, by?: string }} props.created Creation date and author
 * @param {Array<{ title: string, content: string, icon?: Function }>} [props.details]
 *   Labels after "Added Date" and "Added By"; EntitySummary drops the empty ones
 */
export const ProfileSummary = ({
  company = null,
  created,
  details = [],
  location = null,
  status = null
}) => (
  <LayoutBase
    locationInfo={
      <>
        <When condition={company?.id}>
          <Grid item xs="auto">
            <FPLink
              aria-label={COPIES.companyName}
              itemId={company?.id}
              linkProps={COMPANY_LINK_PROPS}
            >
              {company?.name}
            </FPLink>
          </Grid>
        </When>
        <When condition={company?.name && !company?.id}>
          <Grid item xs="auto">
            <strong>{company?.name}</strong>
          </Grid>
        </When>
        <When condition={location}>
          <Grid item xs="auto">
            <Text text={location} />
          </Grid>
        </When>
        <When condition={status}>
          <Grid item xs="auto">
            <ProfileStatusChip
              emailValidationStatus={status?.emailValidationStatus}
              entityTypeId={status?.entityTypeId}
              inventoryType={status?.inventoryType}
              itemStatus={status?.itemStatus}
              optOutStatus={status?.optOutStatus}
              otherEmailValidationStatus={status?.otherEmailValidationStatus}
              subStatus={status?.subStatus}
            />
          </Grid>
        </When>
      </>
    }
    summaryInfo={
      <EntitySummary
        summaryContentProps={{ creationDate: created?.date, creationBy: created?.by }}
        summaryLabels={details}
      />
    }
  />
);
